export var GET_ANNOUNCEMENT_LATEST_INIT = 'GET_ANNOUNCEMENT_LATEST_INIT';
export var GET_ANNOUNCEMENT_LATEST_SUCCESS = 'GET_ANNOUNCEMENT_LATEST_SUCCESS';
export var GET_ANNOUNCEMENT_LATEST_ERROR = 'GET_ANNOUNCEMENT_LATEST_ERROR';
export var GET_ANNOUNCEMENT_LATEST_DONE = 'GET_ANNOUNCEMENT_LATEST_DONE';
